/*
 * @Descripttion: 数据源  状态
 * @version: 
 * @Author: bbq
 * @Date: 2020-05-29 10:59:26
 * @LastEditors: bbqin
 * @LastEditTime: 2021-11-18 16:50:41
 */

import { hookFactory } from '@platform/template';
import { utils, EditTableStore, CONFIG } from '@platform/table-core';
const { uuidv4, isWrong, getPageSizeStorage, isArray, isUndefined, isFunction } = utils;

const { ROW_STATUS } = CONFIG;

class MetaStore extends EditTableStore {
    constructor(props) {
        super(props);
        this.uuid = uuidv4();
        // this.name = 'EditTableStore';
        // 合并一下属性  不然会导致  get 方法取不到值 by bbqin
        this.store = {
            ...this.store,
            allpks: [],
            alltss: [],
            sideBoxConfig: {
                show: false,
                // 就是行的record
                record: {},
                operateType: 'add',
            },
            pageInfo: {
                //pageSize: '10',
                pageIndex: '1',
                total: '0',
                totalPage: '1',
            },
            activeCell: null,
        };
    }

    /*-------------列-------------*/
    /**
    * @description: 设置所有meta
    * @param {type} 
    * @return: 
    */
    setMeta(meta, id, shouldForceUpdate = true) {
        id = id || this.getStore('name');
        let status = this.getTableProps('status');

        // meta上的状态值更新一次 后面都用内部的状态 但是这样也是有BUG的
        if (meta[id] && meta[id].status && !this.isUpdateMetaStatus) {
            status = meta[id].status || status || 'borwse';
            this.isUpdateMetaStatus = true;
        }

        this.setTableProps('status', status, false);
        // console.log('setMeta');
        super.setMeta(meta, id, shouldForceUpdate);
    }

    setTableProps(key, value, shouldForceUpdate = true, callback) {
        // 如果meta上的状态  还没有设置  setTableProps 已经执行  则设置已经更新
        if (key === 'status' && !this.isUpdateMetaStatus) {
            this.tableStatusIsUpdate = true;
        }
        // 拦截处理下特殊情况
        super.setTableProps(key, value, shouldForceUpdate, callback);
    }

    /*-------------缓存-------------*/
    /*-------------私有-------------*/
    /*-------------列-------------*/
    /*-------------单元格-------------*/
    /*-------------行-------------*/
    /*-------------表格-------------*/
    /*-------------高阶组件-------------*/

    /**
     * @description: 获取分页信息
     * @param {type} 
     * @return: 
     */
    getPageInfo() {
        // console.log(this.get(['pageInfo']));
        let prePageSize = getPageSizeStorage(this.getStore(['meta']), this.getStore('name'));
        let pageInfo = this.getStore(['pageInfo']);
        if (!pageInfo.pageSize) {
            pageInfo.pageSize = prePageSize;
        }
        return pageInfo;
    }

    /**
     * @description: 設置分页信息
     * @param {type} 
     * @return: 
     */
    setPageInfo({ shouldForceUpdate = true, pageInfo = {} }) {
        let prevPageInfo = this.get(['pageInfo']) || {};
        prevPageInfo = { ...prevPageInfo, ...pageInfo }
        // console.log(prevPageInfo);
        return this.setStore(['pageInfo'], prevPageInfo, shouldForceUpdate);
    }

    /**
     * @description: 设置表格数据
     * @param {type} 
     * @return: 
     */
    setTableData(data = {}, { isCache = true, isTop = false, shouldForceUpdate = true, autoFocus = true } = {}) {
        let prePageSize = getPageSizeStorage(this.getStore(['meta']), this.getStore('name'));
        // TODO pageInfo
        let allpks = this.getStore(['allpks']);
        let alltss = this.getStore(['alltss'])
        // 设置分页相关数据
        if (data.hasOwnProperty('pageInfo') && !isWrong(data.pageInfo)) {
            // 前端重置后端返回的页码，初次为0，应该改为1，有问题在看看
            data.pageInfo.pageIndex === '0' ? (data.pageInfo.pageIndex = '1') : '';
            //  如果后端返回了值 会导致识别有问题 不能改  很多节点可能有问题
            // if (data.pageInfo.pageIndex && !isNaN(data.pageInfo.pageIndex)) {
            //     data.pageInfo.pageIndex = String(Number(data.pageInfo.pageIndex) + 1);
            // }
        } else if (data.rows.length === 0) {
            data.pageInfo = {
                pageSize: prePageSize,
                pageIndex: '1',
                total: '0',
                totalPage: '1',
            };
        } else {

            if (this && Array.isArray(allpks) && allpks.length > 0) {
                data.pageInfo = this.getPageInfo();
            } else {
                data.pageInfo = {
                    pageSize: prePageSize,
                    pageIndex: '1',
                };
            }
        }

        // 设置分页
        this.setPageInfo({ shouldForceUpdate: false, pageInfo: data.pageInfo })

        // 设置分页的allpks
        if (data.hasOwnProperty('allpks')) {
            this.setStore(['allpks'], data.allpks || allpks || [], false);
        } else if (data.rows.length === 0) {
            this.setStore(['allpks'], [], false);
        } else {
            this.setStore(['allpks'], allpks || [], false);
        }

        if (data.hasOwnProperty('alltss')) {
            this.setStore(['alltss'], data.alltss || alltss || [], false);
        } else if (data.rows.length === 0) {
            this.setStore(['alltss'], [], false);
        } else {
            this.setStore(['alltss'], alltss || [], false);
        }

        data = super.setTableData(data, { isCache, isTop, shouldForceUpdate, autoFocus });
        return data;
    }

    /**
     * @description: 设置表格状态
     * @param {type} 
     * @return: 
     */
    setTableStatus(status, { shouldForceUpdate = true } = {}) {
        super.setTableStatus(status, { shouldForceUpdate });
    }

    /**
     * @description: 删除表格行
     * @param {type} 
     * @return: 
     */
    deleteTableRows({ rowKeyValues, rowIndexs }, thorough, shouldForceUpdate, callback, view) {
        let delItems = super.deleteTableRows({ rowKeyValues, rowIndexs }, thorough, false, callback, view);
        let pageInfo = this.getPageInfo();
        // 这里为了过滤delete之后
        pageInfo && (pageInfo.total -= delItems.length);
        this.setPageInfo({ shouldForceUpdate: false, pageInfo });
        // 处理删除后的勾选逻辑
        let visibleRows = this.getViewData();
        let checkInfo = this.getCheckInfo() || {};
        if (!visibleRows.length) {
            checkInfo.checkedAll = false;
            checkInfo.indeterminate = false;
        } else {
            checkInfo.indeterminate = visibleRows.some(item => !!item.selected);
            checkInfo.checkedAll = visibleRows.every(item => !!item.selected);
        }

        // 更新
        this.setCheckInfo({ checkInfo, shouldForceUpdate, callback });

        return delItems;
    }

    // liumings
    getActiveCell() {
        return this.getStore(['activeCell']);
    }

    //liumings
    setActiveCell(param, shouldForceUpdate = false) {
        this.setStore(['activeCell'], param, shouldForceUpdate);

    }

    // 校验
    checkTableRequired(tableId, { customRules, autoFocus = true } = {}) {

        let json = this.getCache('langJson');

        let metaItems = this.getArrayMeta(tableId);

        if (!metaItems) {
            console.error(`所操作的表格中无ID为${tableId}的meta`);
            return {};
        }
        // 需要校验的数据
        const rows = this.getViewData('filter');

        const allToast = {}; //保存所有检验提示信息

        // 校验
        const validateFailed = {};
        let firstValidateFailed = null;
        const rowKey = this.getTableProps('rowKey');
        let finalContent = ''; //最后展示的content
        let passed = true;

        // 过滤不可见
        metaItems = metaItems.filter(e => e.visible);
        // 按列校验
        metaItems.forEach(item => {
            //将数据中没有的列附上空对象，保证校验的准确性
            const { attrcode, required, label } = item;
            if (isFunction(customRules)) {
                rows.forEach((row, index) => {
                    let { status, values = {} } = row;
                    let saga_status = values.saga_status || {};
                    let validated = true;
                    let rowKeyValue = row[rowKey];

                    validated = customRules({
                        required,
                        rowStatus: status,
                        attrcode,
                        values,
                        row,
                        column: item,
                        rowKeyValue,
                        saga_status,
                    }) || {};

                    if (!validated.passed) {
                        // 记录需要提示的值
                        allToast[index] = allToast[index] || [];
                        allToast[index].push(`[${label}]`);

                        if (!firstValidateFailed) {
                            firstValidateFailed = [rowKeyValue, attrcode];
                        }

                        // 设置校验状态
                        validateFailed[rowKeyValue] = validateFailed[rowKeyValue] || [];
                        validateFailed[rowKeyValue].push(attrcode);
                        this.setCache('validateFailed', validateFailed);
                        this.setCellProps(rowKeyValue, attrcode, { validated: false }, false);
                    }
                });
            } else {
                required && rows.forEach((row, index) => {
                    let { status, values = {} } = row;
                    let saga_status = values.saga_status || {};
                    let validated = true;
                    let rowKeyValue = row[rowKey];

                    // 默认校验规则
                    if (status !== ROW_STATUS.delete && saga_status.value !== '1') { // 去除假删除的
                        if (isUndefined(values[attrcode])) {
                            values[attrcode] = {};
                        }
                        let value = values[attrcode].value;
                        if (isWrong(value) || (isArray(value) && value.length === 0)) {
                            validated = false;
                        }
                    }

                    if (!validated) {
                        // 记录需要提示的值
                        allToast[index] = allToast[index] || [];
                        allToast[index].push(`[${label}]`);

                        if (!firstValidateFailed) {
                            firstValidateFailed = [rowKeyValue, attrcode];
                        }

                        // 设置校验状态
                        validateFailed[rowKeyValue] = validateFailed[rowKeyValue] || [];
                        validateFailed[rowKeyValue].push(attrcode);
                        this.setCache('validateFailed', validateFailed);
                        this.setCellProps(rowKeyValue, attrcode, { validated: false }, false);
                    }
                });
            }
        });

        if (Object.keys(allToast).length > 0) {
            console.log(this, validateFailed, firstValidateFailed, 'validateFailed');
            validateFailed && this.refresh();
            // 聚焦到首个
            if (firstValidateFailed && autoFocus) {
                // cellselectorkey="hhghg-34343m43-434343wws@single1"
                let cellFocusElement = document.querySelector(`.table-cell-wrapper[cellselectorkey="${firstValidateFailed[0]}@${firstValidateFailed[1]}"] [tabindex="0"]`);

                if (cellFocusElement) {
                    cellFocusElement.ncExecuteFocus = true;
                    cellFocusElement.focus();
                    cellFocusElement.ncExecuteFocus = false;
                }
            }
            Object.keys(allToast).forEach(item => {
                //对输出的校验内容进行格式转化
                finalContent += `${json && json['table_first']}${+item + 1} ${json && json['table_row']}: ${allToast[item].join('、')};\n`;
            });

            passed = false;
        }

        return {
            requiredItems: validateFailed,
            regExpItem: [],
            maxItems: [],
            content: `${json && json['table_no_empty']}:\n` + finalContent,
            passed,
        };
    }

    /**
     * @description: 钩子
     * @param {type} 
     * @return: 
     */
    getHooks = () => {
        // console.log(this, super.getHooks());
        // console.log(this);

        return {
            ...this.getTableHooks(),
            getPageInfo: this.getPageInfo.bind(this),
            setPageInfo: this.setPageInfo.bind(this),
            setTableData: this.setTableData.bind(this),
            setTableStatus: this.setTableStatus.bind(this),
            deleteTableRows: this.deleteTableRows.bind(this),
            getActiveCell: this.getActiveCell.bind(this),
            setActiveCell: this.setActiveCell.bind(this),
            setTableProps: this.setTableProps.bind(this),
            checkTableRequired: this.checkTableRequired.bind(this),
            // TODO
        };
    };
}

export default hookFactory(MetaStore);